import React, { type PropsWithChildren } from "react";

import { TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";

import { FIXED_NAME_COLUMN_ID, SELECTION_COLUMN_WIDTH } from "../constants";

export const TableHeaderCell = (
  props: PropsWithChildren<TableHeaderRow.CellProps>,
) => (
  <TableHeaderRow.Cell
    {...props}
    style={
      props.column.name === FIXED_NAME_COLUMN_ID
        ? { left: `${SELECTION_COLUMN_WIDTH}px` }
        : {}
    }
  />
);
